import { types, flow } from "mobx-state-tree";
import fetcher from "../utils/fetcher";
import { getErrorMessage } from "../utils/helper";

const MonthReportsStore = types
  .model("MonthReportsStore", {
    error: types.frozen(),
    monthReports: types.frozen(),
    selectedExpense: types.frozen(),
    selectedReport: types.frozen(),
  })
  .actions((self) => {
    const getMonthReports = flow(function* getMonthReports(data) {
      self.setError("");
      setMonthReports([]);
      const reports = yield fetcher()
        .post(data)
        .from.month_reports.get_user_month_reports();

      if (reports.status === 200 && reports.data) {
        self.setMonthReports(reports.data || []);
      } else {
        const errorText = "error:error_failed_get_month_reports_req";
        self.setError(getErrorMessage(reports, errorText));
      }
    });

    const getMonthReportsStatuses = flow(function* getMonthReportsStatuses() {
      self.setError("");
      setMonthReportsStatuses([]);
      const reports =
        yield fetcher().get.from.month_reports.get_month_reports_statuses();
      if (reports.status === 200 && reports.data) {
        self.setMonthReportsStatuses(reports.data.value || []);
      } else {
        const errorText = "error:error_failed_get_month_reports_statuses_req";
        self.setError(getErrorMessage(reports, errorText));
      }
    });

    const addExpense = flow(function* addExpense(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.add_expense();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_add_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const updateExpense = flow(function* updateExpense(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.update_expense();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_update_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const updateReport = flow(function* updateReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.update_report();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_update_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const addReport = flow(function* updateReport(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.add_report();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_get_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const updateReports = flow(function* updateReports(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.update_reports();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_update_report_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getAbs = flow(function* getAbs() {
      self.setError("");
      const response = yield fetcher().get.from.month_reports.get_abs();
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        const errorText = "error:error_failed_get_abs";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const getGls = flow(function* getGls() {
      self.setError("");
      const response = yield fetcher().get.from.month_reports.get_gls();
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        const errorText = "error:error_failed_get_gls";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    const deleteExpense = flow(function* deleteExpense(data) {
      self.setError("");
      const response = yield fetcher()
        .post(data)
        .from.month_reports.delete_expense();
      if (response.status === 200 && response.data) {
        yield self.getMonthReports(data);
      } else {
        const errorText = "error:error_failed_delete_expense_req";
        self.setError(getErrorMessage(response, errorText));
      }
    });

    function setError(error) {
      self.error = error;
    }

    function setMonthReports(reports) {
      self.monthReports = reports;
    }

    function setMonthReportsStatuses(reports) {
      self.monthReportsStatuses = reports;
    }

    function setSelectedExpense(exp) {
      self.selectedExpense = exp;
    }

    function setSelectedReport(rep) {
      self.selectedReport = rep;
    }

    return {
      getMonthReports,
      getMonthReportsStatuses,
      setMonthReportsStatuses,
      setMonthReports,
      addExpense,
      updateExpense,
      deleteExpense,
      updateReport,
      addReport,
      updateReports,
      getAbs,
      getGls,
      setError,
      setSelectedExpense,
      setSelectedReport,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const monthReportsStore = MonthReportsStore.create({
  error: "",
  monthReports: [],
  setMonthReportsStatuses: [],
  selectedReport: null,
  selectedExpense: null,
});

export default monthReportsStore;
